/* ------------------------------------------------------------------
   IconPicker.js  —  pick a link's icon (Part E, T32)
   A small button showing the current icon; opens a grid of every icon
   in ../../bio/bioIcons.js plus "No icon".
------------------------------------------------------------------ */
import React, { useEffect, useRef, useState } from 'react';
import { BIO_ICONS, BioIcon, iconFor } from '../../bio/bioIcons';

export default function IconPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = iconFor(value);

  useEffect(() => {
    if (!open) return undefined;
    const close = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const esc = e => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', esc); };
  }, [open]);

  const pick = key => { onChange(key); setOpen(false); };

  return (
    <div ref={ref} style={{ position: 'relative', flex: 'none' }}>
      <button type="button" onClick={() => setOpen(o => !o)} aria-haspopup="true" aria-expanded={open}
        aria-label={current ? `Icon: ${current.label}. Change icon` : 'Choose an icon'} title={current ? current.label : 'Choose an icon'}
        style={{ width: 40, height: 38, borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af' }}>
        {current ? <BioIcon name={current.key} brand size={16} /> : <i className="fa-solid fa-icons" aria-hidden="true" />}
      </button>
      {open && (
        <div role="dialog" aria-label="Link icons"
          style={{ position: 'absolute', zIndex: 20, top: 44, left: 0, width: 292, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 12px 28px rgba(15,23,42,0.16)', padding: 10 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4 }}>
            {BIO_ICONS.map(icon => (
              <button key={icon.key} type="button" onClick={() => pick(icon.key)} aria-label={icon.label} title={icon.label}
                aria-pressed={value === icon.key}
                style={{ height: 36, borderRadius: 8, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  border: value === icon.key ? '2px solid #2563eb' : '1px solid transparent', background: value === icon.key ? '#eff6ff' : '#f8fafc' }}>
                <BioIcon name={icon.key} brand size={16} />
              </button>
            ))}
          </div>
          <button type="button" onClick={() => pick('')}
            style={{ marginTop: 8, width: '100%', padding: '6px 10px', fontSize: 12, fontWeight: 600, color: '#374151', background: '#fff', border: '1px solid #d1d5db', borderRadius: 7, cursor: 'pointer' }}>
            No icon
          </button>
        </div>
      )}
    </div>
  );
}
